import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
import { Shield, Zap } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="w-full bg-slate-900 py-20 md:py-28 px-6 relative overflow-hidden" data-id="element-115">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-amber/5 rounded-full blur-[120px] pointer-events-none" data-id="element-116"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-117">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-118">
          <FadeIn data-id="element-119">
            <div className="relative" data-id="element-120">
              <div className="absolute -inset-4 bg-sage-dark/20 rounded-3xl blur-xl -z-10" data-id="element-121"></div>
              <img src="https://cdn.magicpatterns.com/uploads/3GUnHVhEKzuus1wqinPecT/ansiedadexpress.png" alt="Ansiedad Exprés - Guía de Rescate" className="w-full h-auto rounded-2xl shadow-2xl border border-slate-700/50" data-id="element-122" />
            </div>
          </FadeIn>

          <div className="flex flex-col justify-center" data-id="element-123">
            <FadeIn delay={0.2} data-id="element-124">
              <div className="inline-flex items-center gap-2 bg-amber/20 text-amber px-4 py-2 rounded-full text-sm font-bold tracking-wide uppercase mb-6" data-id="element-125">
                <Zap className="w-4 h-4" data-id="element-126" />
                Acceso Inmediato
              </div>
              <h2 className="text-3xl md:text-4xl font-serif text-white mb-6 leading-tight" data-id="element-127">
                Obtén acceso inmediato a "Ansiedad Exprés: Mini Guía para Crisis
                Teens"
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-128">
              <div className="flex items-baseline gap-3 mb-4" data-id="element-129">
                <span className="text-5xl md:text-6xl font-serif text-amber font-bold" data-id="element-130">
                  $17
                </span>
                <span className="text-slate-400 text-lg" data-id="element-131">pago único</span>
              </div>
              <p className="text-slate-300 text-lg mb-8" data-id="element-132">
                Es menos de lo que cuesta una salida al cine, pero con una
                herramienta que tu hijo llevará consigo para siempre.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-133">
              <motion.a href="#oferta" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} animate={{
              boxShadow: ['0px 0px 0px rgba(232, 145, 58, 0)', '0px 0px 20px rgba(232, 145, 58, 0.4)', '0px 0px 0px rgba(232, 145, 58, 0)']
            }} transition={{
              repeat: Infinity,
              duration: 2
            }} className="block w-full bg-amber hover:bg-amber-dark text-white font-bold text-xl py-5 px-8 rounded-xl shadow-lg transition-colors text-center mb-4 no-underline cursor-pointer" data-id="element-134">
                Descargar Guía de Rescate Ahora{' '}
                <span className="line-through opacity-60" data-id="element-135">$34</span> $17
              </motion.a>

              <div className="flex items-center justify-center gap-2 text-slate-400 text-sm mt-4" data-id="element-136">
                <Shield className="w-4 h-4 text-sage" data-id="element-137" />
                Recibe el acceso directamente en tu correo en menos de 60
                segundos.
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}